module.exports = __webpack_public_path__ + "img/hk-back.09e007bc.png";